import type { Props } from './UnexpectedError.types';
import type { ReactElement } from 'react';

import { Box, Button, Flex, Heading, Text } from '@rango-dev/whale';
import { AlertOctagon, RefreshCw } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './UnexpectedError.module.css';

const REFRESH_ICON_SIZE = 16;

export function UnexpectedError(props: Props): ReactElement {
  const { context, onRetry, hasIcon = true } = props;
  const { t } = useTranslation();

  return (
    <Flex direction="column" align="center" gap="5">
      {hasIcon && (
        <Box width={{ initial: '48px', md: '64px' }} height={{ initial: '48px', md: '64px' }}>
          <AlertOctagon color="var(--red-9)" className={styles.icon} />
        </Box>
      )}
      <Flex direction="column" align="center" gap="2">
        <Heading size="5" weight="bold" align="center" className={styles.heading}>
          {t('An unexpected error occurred!')}
        </Heading>
        <Text size="2" weight="medium" color="gray" align="center">
          {t('Please try reloading')}
        </Text>
      </Flex>
      <Button
        id={`${context}-retry-button`}
        size="3"
        variant="solid"
        color="cyan"
        radius="full"
        onClick={onRetry}>
        <RefreshCw size={REFRESH_ICON_SIZE} />
        {t('Retry')}
      </Button>
    </Flex>
  );
}
